import { Input } from 'antd'
import { useEffect, useState } from 'react'
import Button from './Button'

const MilestoneInput = ({ value, onChange }) => {
  const [milestones, setMilestones] = useState(
    value || [{ milestone: '', timeline: '' }],
  )
  const [errors, setErrors] = useState([])

  useEffect(() => {
    setMilestones(value || [{ milestone: '', timeline: '' }])
  }, [value])

  const handleAddRow = () => {
    const updatedMilestones = [...milestones, { milestone: '', timeline: '' }]
    setMilestones(updatedMilestones)
    onChange(updatedMilestones, validate(updatedMilestones))
  }

  const handleRemoveRow = (index) => {
    const updatedMilestones = milestones.filter((_, i) => i !== index)
    setMilestones(updatedMilestones)
    onChange(updatedMilestones, validate(updatedMilestones))
  }

  const handleChange = (index, field, val) => {
    const updatedMilestones = milestones.map((item, i) =>
      i === index ? { ...item, [field]: val } : item,
    )
    setMilestones(updatedMilestones)
    onChange(updatedMilestones, validate(updatedMilestones))

    // Clear errors for the updated field
    const updatedErrors = errors.map((error, i) =>
      i === index ? { ...error, [field]: '' } : error,
    )
    setErrors(updatedErrors)
  }

  const validate = (milestonesToValidate = milestones) => {
    const newErrors = milestonesToValidate.map((item) => ({
      milestone: item.milestone ? '' : 'Milestone is required',
      timeline: item.timeline ? '' : 'Timeline is required',
    }))
    setErrors(newErrors)
    return newErrors.every((error) => !error.milestone && !error.timeline)
  }

  useEffect(() => {
    onChange(milestones, validate(milestones))
  }, [milestones])

  return (
    <div>
      {milestones.map((item, index) => (
        <div key={index} style={{ display: 'flex', marginBottom: '10px' }}>
          <div style={{ flex: 1, marginRight: '10px' }}>
            <Input
              type="text"
              placeholder="Milestone"
              value={item.milestone}
              onChange={(e) => handleChange(index, 'milestone', e.target.value)}
              style={{ width: '100%' }}
            />
            {errors[index]?.milestone && (
              <div style={{ color: 'red' }}>{errors[index].milestone}</div>
            )}
          </div>
          <div style={{ flex: 1 }}>
            <Input
              type="text"
              placeholder="Timeline"
              value={item.timeline}
              onChange={(e) => handleChange(index, 'timeline', e.target.value)}
              style={{ width: '100%' }}
            />
            {errors[index]?.timeline && (
              <div style={{ color: 'red' }}>{errors[index].timeline}</div>
            )}
          </div>
          {index > 0 && (
            <Button
              danger
              htmlType="button"
              onClick={() => handleRemoveRow(index)}
              style={{ marginLeft: '10px' }}
            >
              Remove
            </Button>
          )}
        </div>
      ))}
      <button
        htmlType="button"
        onClick={handleAddRow}
        className="outline-none bg-transparent border border-solid border-g400 text-sm px-2 py-1 rounded-md hover:bg-g500 hover:text-white hover:border-g500"
      >
        Add More
      </button>
    </div>
  )
}

export default MilestoneInput
